export default __webpack_public_path__ + "static/media/logisticYellowRight.d1d6303b.svg";